import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Constants } from '../../core/constants';
import { OverlayManagerService } from '../../services/overlay-manager.service';

export enum MessageBoxType { Error, Info, Warning, Success }

export enum MessageBoxButton { Yes, No, Ok, Cancel }

@Component({
    selector: 'app-message-box',
    templateUrl: './message-box.component.html',
    styleUrls: ['./message-box.component.less']
})
export class MessageBoxComponent implements OnInit {
    @Input() title: string;
    @Input() message: string;
    @Input() messageBoxType: MessageBoxType;
    @Input() callback: Function; // When passing the function to the component, attach ".bind(this)", e.g: myFunction.bind(this)
    @Input() leaveBackgroundBlurredOnClose = false;
    @Input() closeCallback: Function;
    MessageBoxButton = MessageBoxButton;
    iconUrl: string;
    buttonVisibility = {
        yes: false,
        no: false,
        ok: false,
        cancel: false
    };

    constructor(public activeModal: NgbActiveModal,
        private overlayManager: OverlayManagerService) {
    }

    ngOnInit() {
        this.setIconUrlAndButtonVisibility();
    }

    onButtonClicked(button: MessageBoxButton) {
        if (this.callback) {
            this.callback(button);
        }

        this.activeModal.close();
    }

    onMessageBoxClosed() {
        if (this.closeCallback) {
            this.closeCallback();
        }
        if (this.leaveBackgroundBlurredOnClose) return;

        this.overlayManager.toggleBlurBackground.next(false);
    }

    // Helper Methods

    private setIconUrlAndButtonVisibility() {
        this.buttonVisibility.yes = false;
        this.buttonVisibility.no = false;
        this.buttonVisibility.ok = false;
        this.buttonVisibility.cancel = false;

        switch (this.messageBoxType) {
            case MessageBoxType.Error:
                this.iconUrl = Constants.imageBasePath + 'warning@3x.png';
                this.buttonVisibility.ok = true;
                break;
            case MessageBoxType.Info:
                this.iconUrl = Constants.imageBasePath + 'warning@3x.png';
                this.buttonVisibility.ok = true;
                break;
            case MessageBoxType.Warning:
                this.iconUrl = Constants.imageBasePath + 'warning@3x.png';
                this.buttonVisibility.yes = true;
                this.buttonVisibility.no = true;
                break;
            case MessageBoxType.Success:
                this.iconUrl = Constants.imageBasePath + 'congrat@3x.png';
                this.buttonVisibility.ok = true;
                break;
        }
    }

}
